import moment from 'moment';
/**
 * 获取时间
 */
export function getDay(dayNumber = 0, type = 'second') {
  const time = new Date(new Date().getTime() + dayNumber * 24 * 60 * 60 * 1000);
  const year = time.getFullYear();
  const month = time.getMonth() + 1;
  const day = time.getDate();
  const hour = time.getHours();
  const minute = time.getMinutes();
  const second = time.getSeconds();
  const showMonth = (month < 10 ? '0' + month : month);
  const showDay = (day < 10 ? '0' + day : day);
  const showHour = (hour < 10 ? '0' + hour : hour);
  const showMinute = (minute < 10 ? '0' + minute : minute);
  const showSecond = (second < 10 ? '0' + second : second);
  switch (type) {
  case 'month':
    return year + '-' + showMonth;
  case 'day':
    return year + '-' + showMonth + '-' + showDay;
  case 'hour':
    return year + '-' + showMonth + '-' + showDay + ' ' + showHour;
  case 'minute':
    return year + '-' + showMonth + '-' + showDay + ' ' + showHour + ':' + showMinute;
  case 'second':
    return year + '-' + showMonth + '-' + showDay + ' ' + showHour + ':' + showMinute + ':' + showSecond;
  default:
    return year + '-' + showMonth + '-' + showDay + ' ' + showHour + ':' + showMinute + ':' + showSecond;
  }
}
/**
 * 数组转化为对象
 */
export function arrayToMap(list, key) {
  const obj = {};
  list.forEach(item => obj[item[key]] = item);
  return obj;
};
/**
 * 获取客户端标识
 */
export function getClientId() {
  return '5e7d718ffe107b5f13fcdade';
};
/**
 * 根据范围获取中心点
 */
export function getCenterByExtent(extent) {
  const x = (extent[0] + extent[2]) / 2;
  const y = (extent[1] + extent[3]) / 2;
  return [x, y];
};

/**
 * 获取对应环境app下载二维码
*/
export function getQRCode() {
  let url = location.protocol + '//' + location.host;
  if (url.indexOf('jieshou') >= 0) {
    if (url.indexOf('stage.portal.jieshou.chanquan.cacfintech.com') >= 0) {
      return require('@/assets/images/home/qr-code-stage.png');
    }
    if (url.indexOf('stage') >= 0) {
      return require('@/assets/images/home/qr-code-stage1.png');
    }
    if (url.indexOf('test') >= 0) {
      return require('@/assets/images/home/qr-code-test.png');
    }
    if (url.indexOf('dev') >= 0) {
      return require('@/assets/images/home/qr-code-prod.png');
    }
    return require('@/assets/images/home/qr-code-prod.png');
  }
  if (url.indexOf('yingshang') >= 0) {
    if (url.indexOf('test') >= 0) {
      return require('@/assets/images/home/yingshang/test.png');
    }
    return require('@/assets/images/home/yingshang/prod.png');
  }
  if (url.indexOf('linquan') >= 0) {
    if (url.indexOf('test') >= 0) {
      return require('@/assets/images/home/linquan/test.png');
    }
    return require('@/assets/images/home/linquan/prod.png');
  }
};

// 根据用户类型判断单位
export function landUnitByType(projectType) {
  // 建筑物
  if(Number(projectType) === 6)
    return '平方米';
  // 设备设施
  if(Number(projectType) === 7)
    return '台（套）';
  return '亩';
};

// 日期校验 结束日期不能早于开始日期
export function validateDate(startTime, endTime) {
  // 两个日期都不为空时 比较
  if(startTime && endTime) {
    let flag = moment(endTime).isBefore(startTime);
    return flag;
  }
};

export function changeSkin() {
  let url = location.protocol + '//' + location.host;
  if (url.indexOf('caijiazhen') >= 0) {
    document.getElementsByTagName('body')[0].style.setProperty('--townBg', '#00AC42');
    document.getElementsByTagName('body')[0].style.setProperty('--townBgHover', '#007C30');
    document.getElementsByTagName('body')[0].style.setProperty('--townFont', '#4EE688');
    return 'caijiazhen';
  }
  return '';
};

// 判断是否是省级网站 预演环境和生产环境
export function isProvincialSites() {
  let href = window.location.href;
  if(href.indexOf('stage.portal.jieshou.chanquan.cacfintech.com') >= 0 || href.indexOf('http://stage.portal.jieshou.chanquan.cacfintech.com') >= 0 || href.indexOf('portal.jieshou.chanquan.cacfintech.com') >= 0 || href.indexOf('http://portal.jieshou.chanquan.cacfintech.com') >= 0) {
    return true;
  }
  return false;
};

// 根据采购类型判断是投标人还是供应人
export function getValueByType(purchaseType) {
  if([4, 5].includes(Number(purchaseType))) {
    return '投标人';
  }
  return '供应人';
};
// 是否是 依法必招
export function isPurchaseTypeFlag(purchaseType) {
  if([4, 5].includes(Number(purchaseType))) {
    return true;
  }
  return false;
};
// 公告时间根据类型判断 依法必招 自公告之日起20个工作日
export function getAfficheTextByType(purchaseType) {
  // 依法必招
  if(Number(purchaseType) === 5) {
    return '个自然日';
  }
  return '个工作日';
};

// 是否是活体类型
export function getUnitByGoodsType (type) {
  if(Number(type) === 1) {
    return '元/头/只';
  }
  return '元';
};
